import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DateRange } from '../models/dateRange';

@Injectable({
  providedIn: 'root'
})
export class RmDateRangeServiceService {
  private dateRangeUpdater = new BehaviorSubject<DateRange>({
    start: new Date(new Date().getFullYear(), 0, 1),
    end: new Date()
  });

  constructor() { }

   getDateRangeUpdater(): Observable<DateRange> {
    return this.dateRangeUpdater;
   }

   emitDateRangeUpdate(startDate: Date, endDate: Date) {
    this.dateRangeUpdater.next({start: startDate, end: endDate})
   }
}
